var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconContacts01 = function SvgIconContacts01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 24.58,
    y1: -18.82,
    x2: 91.22,
    y2: 81.98,
    gradientTransform: "translate(0 102) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 28.26,
    y1: -21.25,
    x2: 94.89,
    y2: 79.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 12.55,
    y1: -10.83,
    x2: 79.18,
    y2: 89.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 11.97,
    y1: -10.49,
    x2: 78.55,
    y2: 90.22,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M74.25,66.03h-28.82c-.8,0-1.45.65-1.45,1.45s.65,1.45,1.45,1.45h28.82c.8,0,1.45-.65,1.45-1.45s-.65-1.45-1.45-1.45Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.25,74.03h-28.82c-.8,0-1.45.65-1.45,1.45s.65,1.45,1.45,1.45h28.82c.8,0,1.45-.65,1.45-1.45s-.65-1.45-1.45-1.45Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.75,28.47c0-3.05-2.5-5.54-5.54-5.54h-20.68c-3.05,0-5.54,2.5-5.54,5.54v1.3c0,.8.65,1.45,1.45,1.45s1.45-.65,1.45-1.45v-1.3c0-1.45,1.15-2.6,2.6-2.6h20.68c1.45,0,2.6,1.15,2.6,2.6v21.48c-1.75-2.15-4-3.85-6.59-4.95,1-1.3,1.6-2.95,1.6-4.75,0-4.4-3.55-7.94-7.94-7.94s-7.94,3.55-7.94,7.94.6,3.4,1.6,4.75c-2.6,1.05-4.85,2.8-6.59,4.95v-13.39c0-.8-.65-1.45-1.45-1.45s-1.45.65-1.45,1.45v17.53c0,3.05,2.5,5.54,5.54,5.54h20.68c3.05,0,5.54-2.5,5.54-5.54v-25.67.05ZM59.87,35.26c2.75,0,5,2.25,5,5s-2.25,5-5,5-5-2.25-5-5,2.25-5,5-5ZM70.2,56.69h-20.68c-1.05,0-1.9-.6-2.35-1.5,1.6-3.9,4.85-6.84,8.89-8.04,1.15.65,2.45,1,3.8,1s2.7-.35,3.8-1c4.05,1.15,7.29,4.1,8.89,8.04-.4.85-1.3,1.5-2.35,1.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.89,82.62c.8,0,1.45-.65,1.45-1.45V5.59c0-3.1-2.5-5.59-5.59-5.59H21.45c-3.1,0-5.59,2.5-5.59,5.59v4.8h-2.25c-2.75,0-4.95,2.2-4.95,4.95s2.2,4.95,4.95,4.95h2.25v7.44h-2.25c-2.75,0-4.95,2.2-4.95,4.95s2.2,4.95,4.95,4.95h2.25v7.44h-2.25c-2.75,0-4.95,2.2-4.95,4.95s2.2,4.95,4.95,4.95h2.25v7.44h-2.25c-2.75,0-4.95,2.2-4.95,4.95s2.2,4.95,4.95,4.95h2.25v7.44h-2.25c-2.75,0-4.95,2.2-4.95,4.95s2.2,4.95,4.95,4.95h2.25v4.8c0,3.1,2.5,5.59,5.59,5.59h64.29c3.1,0,5.59-2.5,5.59-5.59v-6.29c0-.8-.65-1.45-1.45-1.45s-1.45.65-1.45,1.45v6.29c0,1.5-1.2,2.7-2.7,2.7h-52.05V2.95h52.05c1.5,0,2.7,1.2,2.7,2.7v75.52c0,.8.65,1.45,1.45,1.45ZM11.61,15.33c0-1.1.9-2,2-2h7.39c1.1,0,2,.9,2,2s-.9,2-2,2h-7.39c-1.1,0-2-.9-2-2ZM11.61,32.62c0-1.1.9-2,2-2h7.39c1.1,0,2,.9,2,2s-.9,2-2,2h-7.39c-1.1,0-2-.9-2-2ZM11.61,49.95c0-1.1.9-2,2-2h7.39c1.1,0,2,.9,2,2s-.9,2-2,2h-7.39c-1.1,0-2-.9-2-2ZM11.61,67.28c0-1.1.9-2,2-2h7.39c1.1,0,2,.9,2,2s-.9,2-2,2h-7.39c-1.1,0-2-.9-2-2ZM11.61,84.57c0-1.1.9-2,2-2h7.39c1.1,0,2,.9,2,2s-.9,2-2,2h-7.39c-1.1,0-2-.9-2-2ZM30.79,96.95h-9.34c-1.5,0-2.7-1.2-2.7-2.7v-4.8h2.25c2.75,0,4.95-2.2,4.95-4.95s-2.2-4.95-4.95-4.95h-2.25v-7.44h2.25c2.75,0,4.95-2.2,4.95-4.95s-2.2-4.95-4.95-4.95h-2.25v-7.44h2.25c2.75,0,4.95-2.2,4.95-4.95s-2.2-4.95-4.95-4.95h-2.25v-7.44h2.25c2.75,0,4.95-2.2,4.95-4.95s-2.2-4.95-4.95-4.95h-2.25v-7.44h2.25c2.75,0,4.95-2.2,4.95-4.95s-2.2-4.95-4.95-4.95h-2.25v-4.8c0-1.5,1.2-2.7,2.7-2.7h9.34v94.21Z"
  })));
};
export default SvgIconContacts01;